import { create } from 'zustand';

export interface BackgroundTask {
  id: string;
  type: 'cv_analysis' | 'cl_analysis' | 'cl_generation' | 'interview_analysis';
  recordId: number | string;
  navigateTo: string;
  navigateState?: Record<string, unknown>;
  createdAt: number;
}

interface BackgroundPollingState {
  tasks: BackgroundTask[];
  addTask: (task: Omit<BackgroundTask, 'id' | 'createdAt'>) => void;
  removeTask: (id: string) => void;
  clearAll: () => void;
}

const useBackgroundPollingStore = create<BackgroundPollingState>((set) => ({
  tasks: [],
  addTask: (task) =>
    set((state) => ({
      tasks: [
        ...state.tasks,
        {
          ...task,
          id: `${task.type}_${Date.now()}`,
          createdAt: Date.now(),
        },
      ],
    })),
  removeTask: (id) =>
    set((state) => ({
      tasks: state.tasks.filter((t) => t.id !== id),
    })),
  clearAll: () => set({ tasks: [] }),
}));

export default useBackgroundPollingStore;
